export class LocalStorageHelper {
    static tryGetFromLocalStorage<T>(key: string, defaultObj: T): T {
        if (!localStorage.getItem(key)) {
            return defaultObj;
        } else {
            return JSON.parse(localStorage.getItem(key));
        }
    }

    static trySaveToLocalStorage<T>(key: string, obj: T): void {
        localStorage.setItem(key, JSON.stringify(obj));
    }
}
